import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    campaignId: String
  }
  
  connect() {
    console.log('Priority Inbox connected')
  }
  
  refresh() {
    window.location.reload()
  }
}

